import React, { FC, useCallback } from 'react';

import { BaseControlName } from '../../../feature-player/types/controls';
import { useNextEpisode } from '../../hooks/use-next-episode';
import { useSwitchToNextEpisodeWithAnalytics } from '../../../feature-player/hooks/skin/use-switch-to-next-episode-with-analytics';
import { NextEpisodeButton } from '../../../feature-player/ui/skin/next-episode-button/component';

interface NextEpisodeControlContainerProps {
    contentId: string;
    className?: string;
}

export const NextEpisodeControlContainer: FC<NextEpisodeControlContainerProps> = ({
    contentId,
    className,
}) => {
    const nextEpisode = useNextEpisode(contentId);

    const skip = useSwitchToNextEpisodeWithAnalytics(contentId);

    const handleClick = useCallback(() => {
        skip('NEXT_EPISODE_BUTTON');
    }, [skip]);

    if (!nextEpisode) {
        return null;
    }

    return (
        <div className={className}>
            <NextEpisodeButton
                contentId={contentId}
                name={BaseControlName.NEXT_EPISODE}
                onClick={handleClick}
            />
        </div>
    );
};
